import {
  Box,
  Card,
  CardContent,
  Dialog,
  Divider,
  Typography,
} from "@mui/material"
import WarningRound from "@icons/warning-round"
import { AppLogoutContainer } from "@components"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { ENVIRONMENT, ROUTES } from "@constants"
import { useIdleTimer } from "react-idle-timer"
import { useDispatch } from "react-redux"
import persistStore from "redux-persist/es/persistStore"
import ST0 from "../../utils/constants/session-storage-key.constant"
import store from "../../store/store"
import AppButton from "../app-button/app-button"
import { transactionActions } from "../../store/slices/transaction.slice"
import { homeActions } from "../../store/slices/home.slice"
import { loginActions } from "../../store/slices/login.slice"

function AppLogoutTimer(): JSX.Element {
  const dispatch = useDispatch()
  const [logoutWindow, setLogoutWindow] = useState(false)
  const { t } = useTranslation()
  const navigation = useNavigate()
  const lastUuid = sessionStorage.getItem(ST0.TEMP_UUID_KEY)
  const recordId = sessionStorage.getItem(ST0.RECORD_KEY)

  const logoutUser = async () => {
    dispatch(transactionActions.logout())
    dispatch(homeActions.logout())
    dispatch(loginActions.logout())
    persistStore(store).purge()
  }

  const idleTimer = useIdleTimer({
    timeout: ENVIRONMENT.timeout(),
    onIdle: async () => {
      logoutUser()
      setLogoutWindow(true)
    },
    stopOnIdle: true,
  })

  useEffect(() => {
    if (recordId) {
      idleTimer.reset()
      idleTimer.start()
    } else {
      idleTimer.pause()
    }
  }, [idleTimer, recordId])

  return (
    <Dialog open={logoutWindow} fullScreen>
      <AppLogoutContainer>
        <Card>
          <CardContent>
            <Box>
              <WarningRound />
            </Box>
            <Typography variant="size2">{t("logoutTitle")}</Typography>
            <br />
            <Box>
              <Typography>{t("logoutSubtitle")}</Typography>
            </Box>
            <Box my={2}>
              <Divider />
            </Box>
            <Box textAlign="right">
              <AppButton
                onClick={() => {
                  setLogoutWindow(false)
                  navigation(`${ROUTES.LOGIN()}?statement=${lastUuid}`)
                }}
              >
                {t("loginButton")}
              </AppButton>
            </Box>
          </CardContent>
        </Card>
      </AppLogoutContainer>
    </Dialog>
  )
}

export default AppLogoutTimer
